"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const analytics_context_1 = require("./analytics-context");
exports.withMountTracking = (componentId) => (Component) => {
    var _a;
    return analytics_context_1.withAnalytics((_a = class MountTracker extends React.Component {
            componentWillMount() {
                this.props.track(componentId + ": Mounted", { category: "info" });
            }
            componentWillUnmount() {
                this.props.track(componentId + ": Unmounted", { category: "info" });
            }
            render() {
                return React.createElement(Component, Object.assign({}, this.props));
            }
        },
        _a.displayName = Component.name,
        _a));
};
